import { ca } from '@cian/analytics';
import { selectNewbuilding } from '../../selectors/newbuilding';

import { TThunkAction } from '../../types/redux';
import {
  createUserTrackingData,
  getAnalyticsProductFromNewBuilding,
  getTrackingPageParam,
} from '../../utils/analytics/helpers';

export type TPhoneEventAction = 'Open_buildingprogress_JK' | 'Call';

export function trackingBaseMobilePhoneEvent(action: TPhoneEventAction): TThunkAction {
  return (dispatch, getState, { custom }) => {
    const state = getState();
    const newbuilding = selectNewbuilding(state);

    ca('eventSite', {
      name: 'oldevent',
      category: 'Phones',
      action,
      label: `/sale/jk${newbuilding.customPageUrl}`,
      user: createUserTrackingData(state),
      page: getTrackingPageParam(state, custom.deviceType),
      products: [getAnalyticsProductFromNewBuilding(newbuilding)],
    });
  };
}
